import { apiRequest } from '../../lib/api-client.js';

export interface AuditEntry {
  id: number;
  super_user_id: number | null;
  server_id: number | null;
  action: string;
  payload: Record<string, unknown> | null;
  ip_address: string | null;
  email: string | null;
  created_at: string;
}

export interface AuditQuery {
  super_user_id?: number;
  server_id?: number;
  action?: string;
  limit?: number;
}

export const auditApi = {
  list: (q: AuditQuery = {}) => {
    const params = new URLSearchParams();
    if (q.super_user_id) params.set('super_user_id', String(q.super_user_id));
    if (q.server_id) params.set('server_id', String(q.server_id));
    if (q.action) params.set('action', q.action);
    if (q.limit) params.set('limit', String(q.limit));
    const qs = params.toString();
    return apiRequest<AuditEntry[]>(`/api/audit${qs ? `?${qs}` : ''}`);
  },
};
